import { useEffect, useState } from 'react'

/**
 * useDebouncedValue — devuelve `value` con un retardo de `delay` ms. Cada vez
 * que `value` cambia se reinicia el temporizador, de modo que el valor devuelto
 * solo se actualiza cuando el usuario para de teclear. Pieza compartida por los
 * dos buscadores (la tabla de Búsqueda y el command palette ⌘K) para no duplicar
 * la lógica de debounce.
 */
export function useDebouncedValue<T>(value: T, delay = 280): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])
  return debounced
}
